// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const PlanDetailsDialogLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-plandetailsdialog" */ "./PlanDetailsDialog")).then((bundle)=>{
        return {
            default: bundle.PlanDetailsDialog
        };
    });
export const LazyPlanDetailsDialog = /*#__PURE__*/ lazy(PlanDetailsDialogLazyLoader);
